import React from 'react';
import { List, ListItem } from '../List/index.js';
export function TransferList(props) {
    const { list, handleToggle, checked, boxHeight, boxWidth } = props;
    return (React.createElement(List, { "aria-label": "listBox", style: {
            width: boxWidth,
            height: boxHeight,
            border: '1px solid gray',
            padding: '20px'
        } }, list.map((value) => {
        const show = checked.indexOf(value) !== -1;
        return (React.createElement("div", { key: value.key },
            React.createElement(ListItem, { hasCheckbox: true, checked: checked.indexOf(value) !== -1, onClick: handleToggle(value), disabled: value.disabled }, React.createElement("span", { key: value.key }, ` ${value.field1} ${value.field2} `)),
            React.createElement("div", { className: `twds-pl-4 twds-text-xs ${show ? 'twds-block' : 'twds-hidden'}` }, value.children?.map((child) => {
                return React.createElement("span", { key: child.key }, ` ${child.field1} ${child.field2} `);
            }))));
    })));
}
//# sourceMappingURL=TransferList.js.map